import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { addTestAutomationClassName } from 'utils/misc'

import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import InputAdornment from '@material-ui/core/InputAdornment'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formHelperTextLarge: {
    bottom: -25,
  },
  submitButton: {
    marginTop: 50,
    marginRight: 'auto',
  },
})

const ChangePasswordForm = ({
  dirty,
  values,
  errors,
  classes,
  isSubmitting,
  hasFieldError,
  showNewPassword,
  showOldPassword,
  handleFormSubmit,
  handleFieldChange,
  showConfirmPassword,
  className: classNameProp,
  toggleOldPasswordVisibility,
  toggleNewPasswordVisibility,
  toggleConfirmPasswordVisibility,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('oldPassword')}>
          <TextField
            id="old-password-input"
            name="oldPassword"
            label="Old password"
            value={values.oldPassword}
            onChange={handleFieldChange}
            type={showOldPassword ? 'text' : 'password'}
            error={hasFieldError('oldPassword')}
            margin="normal"
            InputProps={{
              maxLength: 1024,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={toggleOldPasswordVisibility}>
                    {showOldPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            className={addTestAutomationClassName('qa-changepassword-field-oldpassword')}
          />
          {hasFieldError('oldPassword') ? (
            <FormHelperText>{errors.oldPassword}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('newPassword')}>
          <TextField
            id="new-password-input"
            name="newPassword"
            label="New Password"
            value={values.password}
            onChange={handleFieldChange}
            type={showNewPassword ? 'text' : 'password'}
            error={hasFieldError('newPassword')}
            margin="normal"
            InputProps={{
              maxLength: 1024,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={toggleNewPasswordVisibility}>
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            className={addTestAutomationClassName('qa-changepassword-field-newpassword')}
          />
          {hasFieldError('newPassword') ? (
            <FormHelperText className={classes.formHelperTextLarge}>
              {errors.newPassword}
            </FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('confirmPassword')}>
          <TextField
            id="confirm-password-input"
            name="confirmPassword"
            label="Confirm new password"
            value={values.confirmPassword}
            onChange={handleFieldChange}
            type={showConfirmPassword ? 'text' : 'password'}
            error={hasFieldError('confirmPassword')}
            margin="normal"
            InputProps={{
              maxLength: 1024,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={toggleConfirmPasswordVisibility}>
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            className={addTestAutomationClassName('qa-changepassword-field-confirmpassword')}
          />
          {hasFieldError('confirmPassword') ? (
            <FormHelperText>{errors.confirmPassword}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl className={classes.formControl} fullWidth>
          <SubmitButton
            autoFocus
            size="large"
            type="submit"
            color="primary"
            variant="primary"
            showLoader={isSubmitting}
            disabled={isSubmitting || !dirty}
            className={classNames(
              classes.submitButton,
              addTestAutomationClassName('qa-changepassword-button-update')
            )}>
            Update
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

ChangePasswordForm.propTypes = {
  dirty: PropTypes.bool,
  apiCallError: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  errors: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  hasFieldError: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  rememberMe: PropTypes.bool,
  onLogin: PropTypes.func,
  status: PropTypes.string,
  values: PropTypes.object,
  showNewPassword: PropTypes.bool,
  showOldPassword: PropTypes.bool,
  showConfirmPassword: PropTypes.bool,
  toggleOldPasswordVisibility: PropTypes.func,
  toggleNewPasswordVisibility: PropTypes.func,
  toggleConfirmPasswordVisibility: PropTypes.func,
}

export default withStyles(styles)(ChangePasswordForm)



// WEBPACK FOOTER //
// ./src/components/organisms/ChangePasswordForm/ChangePasswordForm.js